exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".read-more {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  text-transform: capitalize; }\n  .read-more:not([href]), .read-more:not([tabindex]) {\n    color: #0094cd !important; }\n  .read-more__icon {\n    margin-left: 2px;\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n    transition: 300ms all ease; }\n    .read-more__icon.open {\n      -webkit-transform: rotate(90deg);\n              transform: rotate(90deg); }\n  .read-more svg {\n    fill: #0094cd;\n    vertical-align: text-top; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/read-more/read-more.component.scss
// module id = ../../../../../src/app/shared/read-more/read-more.component.scss
// module chunks = main